// Sizes / DPR candidates
export const TOTAL_DAYS = 24
export const BG_1X = 1024
export const BG_2X = 2048
export const ITEM_1X = 1024
export const ITEM_2X = 2048

// Paths
const BASE_PATH = 'images/mobile'
export const BG_BASE = `${BASE_PATH}/bg`
export const ITEMS_BASE = `${BASE_PATH}/items`
export const FG_BASE = `${BASE_PATH}/items`
export const MANIFEST_PATH = `${BASE_PATH}/manifest.json`

// Resolve asset URL against Vite's BASE_URL (or root)
export function asset(relative: string) {
  const base = (import.meta.env?.BASE_URL as string | undefined) ?? '/'
  return `${String(base).replace(/\/$/, '')}/${relative.replace(/^\//, '')}`
}
